import packageJson from '../../package.json';

// Stage: 'alpha' | 'beta' | 'stable'
export const RELEASE_STAGE = 'alpha';

export const VERSION = packageJson.version;

export const RELEASE_LABEL =
  RELEASE_STAGE === 'stable'
    ? `v${VERSION}`
    : `${RELEASE_STAGE.charAt(0).toUpperCase() + RELEASE_STAGE.slice(1)} Release — v${VERSION}`;
